import { render, staticRenderFns } from "./CompleteReceiptTable.vue?vue&type=template&id=44745ce5"
import script from "./CompleteReceiptTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompleteReceiptTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports